import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "@/components/Button/Button";
import {
  AUTH_ROUTE_PATHS,
  getSignInPath,
  resolveAuthRole,
} from "@/pages/Auth/authConfig";
import { getCurrentUser, getToken } from "@/lib/utils";
import styles from "./PaymentSuccessfull.module.scss";

const PaymentSuccessfull = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role: roleParam } = useParams();
  const role = resolveAuthRole(roleParam) || resolveAuthRole(getCurrentUser("role"));
  const isPrivateSuccessFlow = !roleParam && Boolean(getToken());
  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo || "/home";
  const planName = (location.state as { planName?: string } | null)?.planName;

  if (!role && !isPrivateSuccessFlow) {
    return <Navigate replace to={AUTH_ROUTE_PATHS.roleSelection} />;
  }

  const handleExploreDinners = () => {
    if (isPrivateSuccessFlow) {
      navigate(returnTo);
      return;
    }

    navigate(getToken() ? "/home" : getSignInPath());
  };

  const description = planName
    ? `${planName} is now active. You can start selecting your dinners for this month.`
    : "Your subscription is now active. You can start selecting your dinners for this month.";

  return (
    <section aria-labelledby="payment-success-title" className={styles.page}>
      <div aria-hidden="true" className={styles.background} />

      <div className={styles.content}>
        <img alt="BFC" className={styles.logo} src="/BFClogo.png" />

        <div className={styles.main}>
          <div className={styles.gifContainer}>
            <img alt="" src="/paymentSuccess.gif" />
          </div>

          <h1 className={styles.title} id="payment-success-title">
            Payment Successful
          </h1>

          <p className={styles.description}>{description}</p>
        </div>

        <div className={styles.buttonWrap}>
          <Button
            className={styles.exploreButton}
            large
            onClick={handleExploreDinners}
            type="button"
          >
            Explore Dinners
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PaymentSuccessfull;
